import { updateUser } from "@/services/auth";
import { createCustomer, createCustomerSession } from "@/services/stripe";
import { useAuthStore } from "@/store/auth.store";
import { t } from "i18next";
import { useEffect, useState } from "react";

const STRIPE_PAGE = import.meta.env.VITE_STRIPE_PAGE;
const STRIPE_KEY = import.meta.env.VITE_STRIPE_KEY;
const STRIPE_TABLE_ID = import.meta.env.VITE_STRIPE_TABLE_ID;

interface UseFlowStripeState {
  data: string | null;
  error: string | null;
  loading: boolean;
}

export default function useFlowStripe(): UseFlowStripeState {
  const [state, setState] = useState<UseFlowStripeState>({
    data: null,
    error: null,
    loading: false,
  });

  const { userData } = useAuthStore();

  function generateURLStep(clientSecret: string): string {
    const url = `${STRIPE_PAGE}?tableId=${STRIPE_TABLE_ID}&key=${STRIPE_KEY}&clientSecret=${clientSecret}`;
    return url;
  }

  const init = async (): Promise<void> => {
    try {
      setState((previous) => ({ ...previous, loading: true, error: null }));
      let clientSecret: string;

      if (userData) {
        if (userData.stripeCustomerId == "") {
          const { id: costumerId } = await createCustomer({
            email: userData.email,
            name: userData.firstname,
          });
          const responseUpdate = await updateUser({
            userId: userData.id,
            stripeCustomerId: costumerId,
          });
          if (!responseUpdate) throw new Error();
          clientSecret = await createCustomerSession({
            customerId: costumerId,
          }).then((value) => value.client_secret);
        } else {
          clientSecret = await createCustomerSession({
            customerId: userData.stripeCustomerId,
          }).then((value) => value.client_secret);
        }
        setState((previous) => ({
          ...previous,
          data: generateURLStep(clientSecret),
          loading: false,
        }));
      }
    } catch {
      setState((previous) => ({
        ...previous,
        data: null,
        loading: false,
        error: t("common.error"),
      }));
    }
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}
